import cx from 'classnames';
import { ADMIN_USER } from 'mk/autogenerated/translations/CommentHeaderName.43e5e6d7cc6b8f1cbf3c333aa94743e0'
import { authorIsModerator, getAnonymousUserPseudonym, isAnonymousUser } from 'mk/bazaar/common/userUtils';
import { CounsellingUserChip } from 'mk2/apps/forum/components/CounsellingUserChip';
import { UserChip } from 'mk2/apps/forum/components/UserChip';
import { CounsellingCounsellorEntity } from 'mk2/apps/forum/schemas';
import Badge, { BadgeType } from 'mk2/components/Badge';
import { CommentEntity, UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './CommentHeaderName.mscss';

interface OwnProps {
    comment: CommentEntity;
    inForum: boolean;
    inGroups: boolean;
    isPostAuthor: boolean;
    isMyAnonymousComment?: boolean;
    moderators: UserEntity[];
    counsellor: CounsellingCounsellorEntity;
}

type Props = OwnProps;

class CommentHeaderName extends React.PureComponent<Props> {
    public render() {
        const { comment, inForum, inGroups, moderators, counsellor, isPostAuthor, isMyAnonymousComment } = this.props;

        const authorIsTopicModerator =
            (inForum || inGroups) &&
            !comment.byAdmin &&
            moderators &&
            authorIsModerator(comment.authorUser, moderators);

        return (
            <>
                {comment.byAdmin ? (
                    <>
                        <strong
                            className={cx(
                                styles.CommentHeaderName__author,
                                styles['CommentHeaderName__author--byAdmin'],
                            )}
                        >
                            {ADMIN_USER}
                        </strong>{' '}
                    </>
                ) : counsellor ? (
                    // don't show author data for counselling, show counselling specific data
                    <CounsellingUserChip counsellor={counsellor} />
                ) : !isAnonymousUser(comment.authorUser) ? (
                    <UserChip
                        user={comment.authorUser}
                        size={inForum ? 24 : 32}
                        showAvatar={inForum}
                        spaceBetween={4}
                        boldUsername
                    />
                ) : comment.anonymousAuthorHash !== 'author' ? (
                    <strong
                        className={cx(
                            styles.CommentHeaderName__author,
                            styles['CommentHeaderName__author--byAnonym'],
                        )}
                    >
                        {getAnonymousUserPseudonym(comment.anonymousAuthorHash)}
                    </strong>
                ) : null}
                {isPostAuthor && (
                    <Badge
                        type={BadgeType.Author}
                        className={styles.CommentHeaderName__badge}
                    />
                )}
                {isMyAnonymousComment && (
                    <Badge
                        type={BadgeType.MyAnonymousComment}
                        className={styles.CommentHeaderName__badge}
                    />
                )}
                {authorIsTopicModerator && (
                    <Badge
                        type={BadgeType.Moderator}
                        className={styles.CommentHeaderName__badge}
                    />
                )}
                {!!comment.authorUser.isAmbassadorOfBrandId &&
                    <Badge
                        type={
                          comment.authorUser.isCommercialAmbassador
                            ? BadgeType.CommercialAmbassador
                            : BadgeType.Ambassador
                        }
                        className={styles.CommentHeaderName__badge}
                    />
                }
                {!!comment.authorUser.isOfficialProfile &&
                    <Badge
                        type={BadgeType.OfficialProfile}
                        className={styles.CommentHeaderName__badge}
                    />
                }
            </>
        );
    }
}

export default CommentHeaderName;
